import VenueFilter from './VenueFilter'

export default VenueFilter
